var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "basic_image", style: _vm.moduleStyle },
    [
      _c("canvas", {
        ref: "headCanvas",
        staticStyle: {
          position: "absolute",
          height: "0",
          width: "0",
          opacity: "0",
        },
      }),
      _vm.base64Img || _vm.src
        ? _c("img", {
            ref: "img",
            staticClass: "my-img cmp-inner",
            style: _vm.style,
            attrs: { src: _vm.base64Img || _vm.src },
            on: {
              "~error": function ($event) {
                return _vm.error.apply(null, arguments)
              },
            },
          })
        : _c("div", {
            ref: "img",
            staticClass: "my-img cmp-inner",
            style: _vm.style,
          }),
      _c("div", { ref: "lottieWrapper", staticClass: "lottie-wrapper" }),
      _vm.module.style["clip-path"]
        ? _c("borderSvg", {
            style: _vm.borderStyle,
            attrs: { module: _vm.module },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }